<template>
  <div>
    <!-- 搜索 -->
    <apply-search
      ref="applySearch"
      @change-search="handleChangeSearch"
      @get-search="setSearchParams"
      :conditions="conditions"
    />

    <Alert show-icon v-if="activityPaymentDescribe">
      {{activityPaymentDescribe.describeTitle}}
      <span slot="desc">
        {{activityPaymentDescribe.describe}}
        <span
          v-show="showPaymentModeRadio"
          class="payment-mode-label"
        >按银行支付条目进行确认</span>
        <i-switch
          size="large"
          v-model="paymentModeCode"
          true-value="confirmByPayment"
          false-value="confirmByApply"
          v-show="showPaymentModeRadio"
        >
          <span slot="open">开启</span>
          <span slot="close">关闭</span>
        </i-switch>
      </span>
    </Alert>

    <!-- 选项卡 -->
    <tabs
      :data="paymentStatusList"
      :props="tabsConfig"
      @byActivityId="setActivityPaymentStatusId"
      ref="tabs"
      class="payment-status"
    />

    <!-- table -->
    <div class="payment-table clearfix">
      <PaymentTable
        :table-data="paymentList"
        :activity-payment-status="activityPaymentStatus"
        :payment-mode="currentPaymentMode"
        :payment-status-list="paymentStatusList"
        ref="paymentTable"
      />
      <!-- page -->
      <Page
        :total="total"
        :current="pagePagination.from"
        :page-size="pagePagination.size"
        :page-size-opts="[50, 100, 150, 200]"
        @on-change="setPaginationFrom"
        @on-page-size-change="setPaginationSize"
        show-elevator
        show-sizer
        class="pagination"
      />
    </div>
  </div>
</template>

<script>
import ApplySearch from "@/components/ApplySearch/ApplySearch";
import Tabs from "@/view/apply-form/components/Tabs";
import PaymentTable from "./components/PaymentTable";
import pagination from "@/view/mixins/pagination";

import Vuex from "vuex";

import {
  conditions,
  paymentStatus,
  paymentDescribe,
  initPaymentModeCode,
} from "./constant";

export default {
  components: {
    ApplySearch,
    Tabs,
    PaymentTable,
  },

  mixins: [pagination],

  data() {
    return {
      conditions: conditions,
      searchParameter: {},
      activityPaymentStatusId: "",

      pagePagination: {
        from: 1,
        size: 50,
      },

      setTableData: this.setPaymentList,

      paymentStatusList: [],
      paymentModeList: [],
      paymentModeCode: initPaymentModeCode,

      tabsConfig: {
        label: "itemName",
        id: "id",
      },

      paymentList: [],
    };
  },
  computed: {
    ...Vuex.mapState({
      refreshPaymentTable: (state) => state.payment.refreshPaymentTable,
    }),

    // 当前的页签状态
    activityPaymentStatus() {
      return this.getPaymentStatusById(this.activityPaymentStatusId);
    },

    // 当前的描述信息
    activityPaymentDescribe() {
      return paymentDescribe[this.activityPaymentStatus.itemCode];
    },

    // 是否展示支付方式单选按钮
    showPaymentModeRadio() {
      return this.activityPaymentStatus.itemCode === "reconciled";
    },

    // 当前的支付方式
    currentPaymentMode() {
      const modeObj = this.paymentModeList.find(
        (item) => item.itemCode === this.paymentModeCode
      );
      return modeObj || {};
    },
  },

  watch: {
    activityPaymentStatusId: {
      deep: true,
      handler(newValue) {
        this.$nextTick(() => {
          this.$refs.applySearch.resetSearchParameter();
        });
        this.initPaymentMode();
      },
    },

    refreshPaymentTable: {
      handler() {
        this.setPaymentList();
      },
    },
  },

  created() {
    this.setPaymentStatusList();
    this.setPaymentModeList();
  },

  methods: {
    async setPaymentStatusList() {
      const paymentStatusEnumTypes = await this.$api.enumTypeCode(
        "paymentStatus"
      );

      this.paymentStatusList = paymentStatusEnumTypes.filter(
        (item) => paymentStatus.indexOf(item.itemCode) >= 0
      );
      this.$nextTick(
        (_) => (this.$refs.tabs.activityId = paymentStatusEnumTypes[0].id)
      );
    },

    setPaymentModeList() {
      this.$api.enumTypeCode("wait_reconciliation_confirm_type").then((res) => {
        this.paymentModeList = res;
      });
    },

    setActivityPaymentStatusId(id) {
      this.activityPaymentStatusId = id;
    },

    initPaymentMode() {
      this.paymentModeCode = initPaymentModeCode;
    },

    clearPaymentListSelected() {
      this.$refs.paymentTable.paymentListSelected = [];
    },

    setPaymentList() {
      this.clearPaymentListSelected();
      const params = Object.assign(
        this.$lodash.cloneDeep(this.pagePagination),
        {
          params: this.searchParameter,
        }
      );

      this.$api
        .getPaymentList(params, this.activityPaymentStatus.itemCode)
        .then((res) => {
          this.total = res.total;
          this.paymentList = res.records;
        });
    },

    getPaymentStatusById(enumId) {
      if (!this.paymentStatusList.length || !enumId) {
        return {};
      }
      return this.paymentStatusList.find((item) => item.id === enumId);
    },

    setSearchParams(search) {
      const {
        applyTypeEnumItemCode,
        projectId,
        departmentIds,
        queryName,
      } = search;
      let searchParameter = {};

      if (applyTypeEnumItemCode) {
        searchParameter.applyTypeEnumItemCode = applyTypeEnumItemCode;
      }
      if (projectId) {
        searchParameter.projectId = projectId;
      }
      if (departmentIds && departmentIds.length) {
        searchParameter.departmentId = departmentIds[0];
      }
      if (queryName) {
        searchParameter.queryName = queryName;
      }

      this.searchParameter = this.$lodash.cloneDeep(searchParameter);
    },

    handleChangeSearch() {
      if (this.resetPaginationFrom()) return;
      this.setPaymentList();
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
::v-deep .ivu-alert {
  margin: 30px 20px 20px 20px;
  padding: 25px 16px 25px 69px;
  border-radius: 10px;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.07);

  .ivu-alert-desc {
    line-height: 35px;
  }

  ::v-deep .payment-mode-label {
    color: #2d8cf0;
  }
}

.payment-status {
  display: flex;
  margin-left: 50px;
}

.payment-table {
  position: relative;
  z-index: 10;
  margin: 0 20px 100px 20px;
  padding: 20px;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.07);
  border-radius: 10px;
  background: rgba(255, 255, 255, 1);
}

.pagination {
  margin: 20px 0;
  float: right;
}

.form-label {
  display: inline-block;
  width: 120px;
}
</style>